import * as Yup from 'yup';
import { formatPrice } from '../../utils/func';


export const guestRequiredDetail = (data, prefillGuestData, guestQuantity, allUniqueRequiredFields, tempPreFilledData) => {

  function addMissingFields(data, requiredFields) {
    return data.map(entry => {
      requiredFields.forEach(field => {
        if (!(field in entry)) {
          entry[field] = field === "lead_guest" ? false : {
            condition: "pre_download",
            error: null,
            value: null
          };
        }
      });
      return entry;
    });
  }

  const guestInfo = prefillGuestData?.[0]?.guestInfo || [];
  const tempFilled = tempPreFilledData?.[0]?.guests || [];
  const dataArray = Array.isArray(data) ? addMissingFields(data, allUniqueRequiredFields) : [];
  const longestArray = [dataArray, tempFilled, guestInfo].reduce((a, b) => (a?.length >= b?.length ? a : b), []);

  if (longestArray.length > 0) {
    return longestArray.map((_, index) => {
      let guestObject = {
        lead_guest: dataArray?.[index]?.lead_guest ?? tempFilled?.[index]?.lead_guest ?? guestInfo?.[index]?.lead_guest ?? false,
        activeGuest: dataArray?.[index]?.activeGuest ?? tempFilled?.[index]?.activeGuest ?? guestInfo?.[index]?.activeGuest ?? true,
      };

      const sourceItem = dataArray?.[index] || tempFilled?.[index] || guestInfo?.[index] || {};

      Object.keys(sourceItem).forEach((key) => {
        if (key !== "lead_guest" && key !== "activeGuest") {
          guestObject[key] =
            dataArray?.[index]?.[key]?.value ??
            tempFilled?.[index]?.[key]?.value ??
            guestInfo?.[index]?.[key] ??
            "";
        }
      });

      return guestObject;
    });
  }

  return Array.from({ length: guestQuantity }, (_, index) => {
    const guestObject = allUniqueRequiredFields?.reduce((acc, field) => {
      acc[field] = guestInfo?.[index]?.[field] || tempFilled?.[index]?.[field].value || "";
      return acc;
    }, {});

    return {
      ...guestObject,
      lead_guest: index === 0,
      activeGuest: true,
      onlyTRP: true
    };
  });

};


export const GUEST_DATA_INITIAl_VALUE = (guestData, categorisedData, eventRequirements, preCheckoutDetails, checkForCheckoutPage, allUniqueRequiredFields, preFilledData) => {
  return {
    BookingData: Object.entries(categorisedData).map(([eventName, tickets]) => {
      return {
        eventName,
        eventRequirements: eventRequirements?.filter((item) => Object.keys(item)?.[0] === tickets?.[0].event_id),
        tickets: tickets.map((item) => {
          const guestsForTicket = guestData?.filter((guest) => guest?.ticket_id === item?.ticket_id)?.[0];
          const prefillGuestData = preCheckoutDetails?.filter((guestInfo) => guestInfo?.ticket_id === item?.ticket_id)
          const tempPreFilledData = preFilledData?.filter((guestInfo) => guestInfo?.ticket_id === item?.ticket_id)
          return {
            ticket: item,
            guestDetail: guestsForTicket,
            guests: guestRequiredDetail(guestsForTicket?.guests, prefillGuestData, guestsForTicket?.quantity, allUniqueRequiredFields, tempPreFilledData),
            quantity: guestsForTicket?.quantity,
            ticket_id: guestsForTicket?.ticket_id
          };
        })
      };
    }),
    ticket_mail: "",
    price_markup: preFilledData?.[0]?.price_markup ?? "0",
    markup_percentage: preFilledData?.[0]?.markup_percentage ?? "",
    filGuestLater: false,
    termsAndCondition: checkForCheckoutPage ? true : false,
    payement_reference: "",
    booking_refrence: ""
  };
};

const checkForIsfieldRequired = (eventRequirementValues, fieldName, index, eventKey, requiredFields) => {
  const eventRequiredData = [eventRequirementValues?.[eventKey], ...requiredFields].sort()
  const checkForKeyRequiredOrNot = eventRequiredData?.includes(fieldName)
  const preCheckoutRequired = eventRequiredData?.includes("pre_checkout");
  const allPersonRequire = eventRequiredData?.includes("all_persons");
  const requireLeadGuest = eventRequiredData?.includes("lead_guest");
  const fieldRequired = eventRequiredData?.includes(fieldName);
  const isLeadGuest = index === 0;

  if (eventRequiredData?.length === 0) {
    if (requiredFields?.includes(fieldName)) {
      return true
    }
    return false
  } else {
    if (checkForKeyRequiredOrNot) {
      return true
    }
    return false
  }
}

export const guestDataValidationSchema = (eventRequirements, allUniqueRequiredFields, totalPrice) => {
  let eventIndex;
  let ticketIndex;
  return Yup.object().shape({
    BookingData: Yup.array().of(
      Yup.object().when('$bookingRequirement', (_, schema, context) => {
        eventIndex = context.index
      }).shape({
        tickets: Yup.array().of(Yup.object().when('ticketRequirement', (_, schema, ticketContext) => {
          ticketIndex = ticketContext?.index
        }).shape({
          guests: Yup.array().of(Yup.object().shape({
            first_name: Yup.string()
              .required('First name is required')
              .trim()
              .min(2, 'First name must be at least 2 characters')
              .max(50, 'First name must be at most 50 characters')
              .when('$eventRequirements', (_, schema, context) => {
                const eventRequirementValues = eventRequirements?.[eventIndex]
                let eventKey;
                for (let key in eventRequirementValues) {
                  eventKey = key
                }
                return checkForIsfieldRequired(eventRequirementValues, "first_name", context?.index, eventKey, allUniqueRequiredFields) ? schema.required('First name is required') : schema.notRequired();
              }),
            gender: Yup.string()
              .required('Gender is required')
              .when('$eventRequirements', (_, schema, context) => {
                const eventRequirementValues = eventRequirements?.[eventIndex]
                let eventKey;
                for (let key in eventRequirementValues) {
                  eventKey = key
                }
                return checkForIsfieldRequired(eventRequirementValues, "gender", context?.index, eventKey, allUniqueRequiredFields) ? schema.required('Gender is required') : schema.notRequired();
              }),
            last_name: Yup.string()
              .required('Last name is required')
              .trim()
              .min(2, 'Last name must be at least 2 characters')
              .max(50, 'Last name must be at most 50 characters')
              .when('$eventRequirements', (_, schema, context) => {
                const eventRequirementValues = eventRequirements?.[eventIndex]
                let eventKey;
                for (let key in eventRequirementValues) {
                  eventKey = key
                }
                return checkForIsfieldRequired(eventRequirementValues, "last_name", context?.index, eventKey, allUniqueRequiredFields) ? schema.required('Last name is required') : schema.notRequired();

              }),
            contact_email: Yup.string()
              .required('Contact email is required')
              .email('Invalid email format')
              .when('$eventRequirements', (_, schema, context) => {
                const eventRequirementValues = eventRequirements?.[eventIndex]
                let eventKey;
                for (let key in eventRequirementValues) {
                  eventKey = key
                }
                return checkForIsfieldRequired(eventRequirementValues, "contact_email", context?.index, eventKey, allUniqueRequiredFields) ? schema.required('Contact email is required') : schema.notRequired();

              }),
            contact_phone: Yup.string()
              .required('Contact email is required')
              .matches(/^\d{10,15}$/, 'Phone number must be 10 to 15 digits')
              .when('$eventRequirements', (_, schema, context) => {
                const eventRequirementValues = eventRequirements?.[eventIndex]
                let eventKey;
                for (let key in eventRequirementValues) {
                  eventKey = key
                }
                return checkForIsfieldRequired(eventRequirementValues, "contact_phone", context?.index, eventKey, allUniqueRequiredFields) ? schema.required('Phone number is required') : schema.notRequired();

              }),
            zip: Yup.string()
              .required('Zip is required')
              .matches(/^\d{4,10}$/, 'Zip code must be between 4 and 10 digits')
              .when('$eventRequirements', (_, schema, context) => {
                const eventRequirementValues = eventRequirements?.[eventIndex]
                let eventKey;
                for (let key in eventRequirementValues) {
                  eventKey = key
                }
                return checkForIsfieldRequired(eventRequirementValues, "zip", context?.index, eventKey, allUniqueRequiredFields) ? schema.required('Phone number is required') : schema.notRequired();

              }),
            street_name: Yup.string()
              .required('Street name is required')
              .trim()
              .min(3, 'Street name must be at least 3 characters')
              .max(100, 'Street name must be at most 100 characters')
              .when('$eventRequirements', (_, schema, context) => {
                const eventRequirementValues = eventRequirements?.[eventIndex]
                let eventKey;
                for (let key in eventRequirementValues) {
                  eventKey = key
                }
                return checkForIsfieldRequired(eventRequirementValues, "street_name", context?.index, eventKey, allUniqueRequiredFields) ? schema.required('Street name is required') : schema.notRequired();

              }),
            passport_number: Yup.string()
              .required('Passport number is required')
              .matches(/^[A-PR-WYa-pr-wy][1-9]\d\s?\d{4}[1-9]$/, 'Invalid passport number')
              .when('$eventRequirements', (_, schema, context) => {
                const eventRequirementValues = eventRequirements?.[eventIndex]
                let eventKey;
                for (let key in eventRequirementValues) {
                  eventKey = key
                }
                return checkForIsfieldRequired(eventRequirementValues, "passport_number", context?.index, eventKey, allUniqueRequiredFields) ? schema.required('Passport number is required') : schema.notRequired();

              }),
            country_of_residence: Yup.string()
              .required('Country of residence is required')
              .when('$eventRequirements', (_, schema, context) => {
                const eventRequirementValues = eventRequirements?.[eventIndex]
                let eventKey;
                for (let key in eventRequirementValues) {
                  eventKey = key
                }
                return checkForIsfieldRequired(eventRequirementValues, "country_of_residence", context?.index, eventKey, allUniqueRequiredFields) ? schema.required('Country of residence is required') : schema.notRequired();

              }),
            city: Yup.string()
              .required('City is required')
              .when('$eventRequirements', (_, schema, context) => {
                const eventRequirementValues = eventRequirements?.[eventIndex]
                let eventKey;
                for (let key in eventRequirementValues) {
                  eventKey = key
                }
                return checkForIsfieldRequired(eventRequirementValues, "city", context?.index, eventKey, allUniqueRequiredFields) ? schema.required('City is required') : schema.notRequired();

              }),
            date_of_birth: Yup.string()
              .required('Date of birth is required')
              .max(new Date(), 'Date of birth cannot be in the future')
              .when('$eventRequirements', (_, schema, context) => {
                const eventRequirementValues = eventRequirements?.[eventIndex]
                let eventKey;
                for (let key in eventRequirementValues) {
                  eventKey = key
                }
                return checkForIsfieldRequired(eventRequirementValues, "date_of_birth", context?.index, eventKey, allUniqueRequiredFields) ? schema.required('Date of birth is required') : schema.notRequired();

              }),

          }))
        })).test(
          'activeGuest-quantity-validation',
          'Number of active guests exceeds the selected ticket quantity',
          function (value) {
            const { path, createError, parent } = this;
            const tickets = parent?.tickets;
            for (let ticketIndex = 0; ticketIndex < tickets.length; ticketIndex++) {
              const ticket = tickets[ticketIndex];
              const ticketQuantity = ticket?.quantity;
              const activeGuestCount = ticket?.guests?.filter(guest => guest.activeGuest).length || 0;
              if (activeGuestCount > ticketQuantity) {
                return createError({
                  path: `BookingData[${eventIndex}].tickets[${ticketIndex}].ticketError`,
                  message: `Please select only ${ticketQuantity} active guests for this ticket.`,
                });
              }
              else if (ticketQuantity > activeGuestCount) {
                return createError({
                  path: `BookingData[${eventIndex}].tickets[${ticketIndex}].ticketError`,
                  message: `Please select  ${ticketQuantity} active guests for this ticket.`,
                });
              }
            }
            return true;
          }
        )
      })
    ),
    price_markup: Yup.number()
      .nullable()
      .transform((value, originalValue) => {
        return originalValue === '' || isNaN(originalValue) ? null : Number(originalValue);
      })
      .test(
        'is-zero-or-above-total',
        function (value) {
          console.log(value, "valueeeee");
          if (value === null || value === 0) return true;
          return value >= totalPrice || this.createError({
            message: `Price markup must be 0 or greater than ${formatPrice(totalPrice)}`,
          });
        }
      ),
    termsAndCondition: Yup.boolean()
      .oneOf([true], "*Accept the terms and conditions"),
    // ticket_mail: Yup.string().email("Invalid email").required("Email is required to download the ticket"),
    // payement_reference: Yup.string().required("Payment reference is required"),
    // booking_refrence: Yup.string().required("Booking reference is required")
  });
} 